import FlowSimpleList from '../flows/FlowSimpleList.react';
import AppPanel from '../fw/AppPanel.react';
import config from '../../common/config';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import bootbox from 'bootbox';
import ChannelList from '../channels/ChannelList.react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import DeleteButton from '../fw/DeleteButton.react';
import ConfirmDialog from '../fw/ConfirmDialog.react';
import ScenarioBox from '../scenarios/ScenarioBox.react';
import * as FeatureFlags from '../../common/util/FeatureFlags.ts';
import {parseOrganisationLabels} from '../../common/util/OrganisationLabels.ts';
import * as BrowserPermission from "../BrowserPermission";
import * as Permission from '../../common/util/Permission';
import OkDialog from '../fw/OkDialog.react';
import Link from 'react-router/lib/Link';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import UserRenderer from '../users/UserRenderer.react';
import SafeHTML from '../fw/SafeHTML.react';
import { getUISettings } from '../app/UISettings.react.js';

import './Organisation.scss';
import { User } from '../../common/types/types';
import AnnouncementBox from '../announcements/AnnouncementBox.react.js';
import BlockUnblockOrganisationMutation from './mutations/BlockUnblockOrganisationMutation.react';
import {displayError} from '../app/errorDisplayer';
import mutationError from '../channel-defs/mutationError';

export const messages = defineMessages({
    deleteTitle: {id: 'deleteConfirmation.title', 'defaultMessage': 'Do you really want to delete?'},
    deleteLastTitle: {id: 'deleteConfirmation.lastTitle', 'defaultMessage': 'Do you really want to delete? This is your last organisation, we will create you new one instantly.'},
    myDativery: {id: 'menu.home2', 'defaultMessage': 'My Organisation'},
    search: {id: 'myDativery.search', 'defaultMessage': 'Search'},
    connectMoreApps: {id: 'myDativery.connect', "defaultMessage": 'Connect more applications'},
    cantDelete: {id: 'organisation.cantDelete2', "defaultMessage": "Organisation is not empty. Delete all flows and then disconnect all applications to empty it."},
    feedbackLongText: {id: 'feedback.longText', "defaultMessage": "If you have a moment, please let us know the reasons for the deletion."},
    addonSettingsButton: {id: 'organisation.addonSettingsButton', 'defaultMessage': 'Addon Settings'},

    missingBillingTitle: {id: 'organisation.missingBillingTitle', 'defaultMessage': 'Fill in billing information'},
    missingBillingText: {id: 'organisation.missingBillingText', 'defaultMessage': '<p>This organization does not have sufficient billing information.</p><p>Can you please fill in the required information or set up <a href="https://www.dativery.com/cs/blogy/fakturace/#nsf" target="_blank">combined billing</a> in the organization settings under Billing information?</p>'},
    missingBillingAction: {id: 'organisation.missingBillingAction', 'defaultMessage': 'Go to billing information'},

    invoicesBannerTitle: { id: 'organisation.invoicesBanner.title', defaultMessage: 'Invoices summary' },
    invoicesBannerWarningText: { id: 'organisation.invoicesBanner.warningText', defaultMessage: 'Attention: this organisation has unpaid invoices' },
    invoicesBannerOverdue: { id: 'organisation.invoicesBanner.overdue', defaultMessage: 'Overdue' },
    invoicesBannerUpTo30: { id: 'organisation.invoicesBanner.bucket.upTo30', defaultMessage: 'Overdue up to 30 days' },
    invoicesBanner31to60: { id: 'organisation.invoicesBanner.bucket.31to60', defaultMessage: 'Overdue 31–60 days' },
    invoicesBanner61to90: { id: 'organisation.invoicesBanner.bucket.61to90', defaultMessage: 'Overdue 61–90 days' },
    invoicesBannerOver90: { id: 'organisation.invoicesBanner.bucket.over90', defaultMessage: 'Overdue over 90 days' },
    invoicesBannerPaid: { id: 'organisation.invoicesBanner.paid', defaultMessage: 'Paid' },
    invoicesBannerDue: { id: 'organisation.invoicesBanner.due', defaultMessage: 'Due' },
    invoicesBannerOpenInvoices: { id: 'organisation.invoicesBanner.openInvoices', defaultMessage: 'Open invoices list' },
    blockOrganisation: { id: 'organisation.blockOrganisation', defaultMessage: 'Block organisation' },
    unblockOrganisation: { id: 'organisation.unblockOrganisation', defaultMessage: 'Unblock organisation' },
    blockOrganisationReasonTitle: { id: 'organisation.blockOrganisationReasonTitle', defaultMessage: 'Block organisation' },
    blockOrganisationReasonPrompt: { id: 'organisation.blockOrganisationReasonPrompt', defaultMessage: 'Please enter the reason for blocking this organisation:' },
    blockOrganisationReasonRequired: { id: 'organisation.blockOrganisationReasonRequired', defaultMessage: 'Block reason is required.' },
    blockOrganisationConfirmText: { id: 'organisation.blockOrganisationConfirmText', defaultMessage: 'Block' },
    unblockOrganisationDescription: { id: 'organisation.unblockOrganisationDescription', defaultMessage: 'Do you want to unblock this organisation and allow processing?' },
});

interface OrganisationViewProps {
 intl: IntlShape;
 relay?: object;
 user: User;
}

class OrganisationView extends React.Component<OrganisationViewProps> {

    typeName = 'organisations';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.usedScenariosEl = null;

        this.state = {
            usedScenariosOverflow: false
        };
    }

    formatMoneyAmount(amount) {
        const n = Number(amount || 0);
        return this.props.intl.formatNumber(n, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    renderOrganisationInvoicesBanner(org) {
        if (!org || !org.organisationOverdueBills || !org.organisationOverdueBills.edges) return null;

        const edges = org.organisationOverdueBills.edges || [];
        if (!edges.length) return null;

        const showPaid = BrowserPermission.isDeveloper(org.realId);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        let hasOverdue = false;

        let dueCZK = 0;
        let dueEUR = 0;
        let dueOther = 0;
        let dueOtherCurrency = null;

        let paidCZK = 0;
        let paidEUR = 0;
        let paidOther = 0;
        let paidOtherCurrency = null;

        // Overdue period buckets (same as Organisations tab: up30 / 31–60 / 61–90 / 90+)
        let dueUp30CZK = 0, dueUp30EUR = 0, dueUp30Other = 0;
        let due31to60CZK = 0, due31to60EUR = 0, due31to60Other = 0;
        let due61to90CZK = 0, due61to90EUR = 0, due61to90Other = 0;
        let dueOver90CZK = 0, dueOver90EUR = 0, dueOver90Other = 0;

        edges.forEach((e) => {
            const b = e && e.node ? e.node : null;
            if (!b) return;

            let currency = String(b.currencyCode || '').trim();
            if (currency && currency.toLowerCase().indexOf('code:') === 0) currency = currency.substring(5).trim();
            if (!currency) currency = 'CZK';

            const amountToPay = Number(b.amountToPay || 0);
            const totalAmount = Number(b.totalAmount || 0);
            if (showPaid) {
                const paidPart = Math.max(totalAmount - amountToPay, 0);
                // Paid = sum of paid parts across all available invoices (informational).
                if (currency === 'CZK') {
                    paidCZK += paidPart;
                } else if (currency === 'EUR') {
                    paidEUR += paidPart;
                } else {
                    paidOther += paidPart;
                    if (!paidOtherCurrency && paidPart > 0) paidOtherCurrency = currency;
                }
            }

            // Overdue = unpaid invoices past due date only (this drives banner visibility + "Overdue" amount).
            if (amountToPay > 0 && b.dueDate) {
                const dueDate = new Date(b.dueDate);
                if (isNaN(dueDate.getTime())) return;
                // Compare dates only (ignore time).
                dueDate.setHours(0, 0, 0, 0);

                if (dueDate < today) {
                    hasOverdue = true;
                    if (currency === 'CZK') {
                        dueCZK += amountToPay;
                    } else if (currency === 'EUR') {
                        dueEUR += amountToPay;
                    } else {
                        dueOther += amountToPay;
                        if (!dueOtherCurrency) dueOtherCurrency = currency;
                    }

                    const daysOverdue = Math.floor((today.getTime() - dueDate.getTime()) / (24 * 60 * 60 * 1000));
                    if (daysOverdue <= 30) {
                        if (currency === 'CZK') dueUp30CZK += amountToPay;
                        else if (currency === 'EUR') dueUp30EUR += amountToPay;
                        else dueUp30Other += amountToPay;
                    } else if (daysOverdue <= 60) {
                        if (currency === 'CZK') due31to60CZK += amountToPay;
                        else if (currency === 'EUR') due31to60EUR += amountToPay;
                        else due31to60Other += amountToPay;
                    } else if (daysOverdue <= 90) {
                        if (currency === 'CZK') due61to90CZK += amountToPay;
                        else if (currency === 'EUR') due61to90EUR += amountToPay;
                        else due61to90Other += amountToPay;
                    } else {
                        if (currency === 'CZK') dueOver90CZK += amountToPay;
                        else if (currency === 'EUR') dueOver90EUR += amountToPay;
                        else dueOver90Other += amountToPay;
                    }
                }
            }
        });

        // Banner only if there is at least one overdue unpaid invoice
        if (!hasOverdue) return null;

        const renderParts = (czk, eur, other, otherCurrencyFallback) => {
            const parts = [];
            if (czk > 0) parts.push(`${this.formatMoneyAmount(czk)} CZK`);
            if (eur > 0) parts.push(`${this.formatMoneyAmount(eur)} EUR`);
            if (other > 0) parts.push(`${this.formatMoneyAmount(other)} ${otherCurrencyFallback || 'OTHER'}`);
            return parts.length ? parts.join(' | ') : '—';
        };

        let paidText = null;
        if (showPaid) {
            // For "Paid" show currencies that exist in "Due" (even if paid is 0)
            const paidParts = [];
            if (dueCZK > 0) paidParts.push(`${this.formatMoneyAmount(paidCZK)} CZK`);
            else if (paidCZK > 0) paidParts.push(`${this.formatMoneyAmount(paidCZK)} CZK`);
            if (dueEUR > 0) paidParts.push(`${this.formatMoneyAmount(paidEUR)} EUR`);
            else if (paidEUR > 0) paidParts.push(`${this.formatMoneyAmount(paidEUR)} EUR`);
            if (dueOther > 0) paidParts.push(`${this.formatMoneyAmount(paidOther)} ${paidOtherCurrency || dueOtherCurrency || 'OTHER'}`);
            else if (paidOther > 0) paidParts.push(`${this.formatMoneyAmount(paidOther)} ${paidOtherCurrency || 'OTHER'}`);
            paidText = paidParts.length ? paidParts.join(' | ') : '—';
        }

        const dueText = renderParts(dueCZK, dueEUR, dueOther, dueOtherCurrency);
        const dueUp30Text = renderParts(dueUp30CZK, dueUp30EUR, dueUp30Other, dueOtherCurrency);
        const due31to60Text = renderParts(due31to60CZK, due31to60EUR, due31to60Other, dueOtherCurrency);
        const due61to90Text = renderParts(due61to90CZK, due61to90EUR, due61to90Other, dueOtherCurrency);
        const dueOver90Text = renderParts(dueOver90CZK, dueOver90EUR, dueOver90Other, dueOtherCurrency);
        const invoicesUrl = urlMapping.getUrl('invoices', 'list', org);

        const hasBucketUp30 = (dueUp30CZK + dueUp30EUR + dueUp30Other) > 0;
        const hasBucket31to60 = (due31to60CZK + due31to60EUR + due31to60Other) > 0;
        const hasBucket61to90 = (due61to90CZK + due61to90EUR + due61to90Other) > 0;
        const hasBucketOver90 = (dueOver90CZK + dueOver90EUR + dueOver90Other) > 0;

        return (
            <div className="alert organisationInvoicesBanner">
                <div className="organisationInvoicesBanner__layout">
                    <div className="organisationInvoicesBanner__accent" aria-hidden="true">
                        <i className="fa fa-exclamation organisationInvoicesBanner__accentIcon" />
                    </div>
                    <div className="organisationInvoicesBanner__content">
                        <div className="organisationInvoicesBanner__headline">
                            <span className="organisationInvoicesBanner__warningText">
                                <FormattedMessage {...messages.invoicesBannerWarningText} />
                            </span>
                        </div>
                        <div className="organisationInvoicesBanner__details">
                            <div className="organisationInvoicesBanner__summaryRow">
                                <div className="organisationInvoicesBanner__summaryMain">
                                    <span className="organisationInvoicesBanner__summaryLabel">
                                        <FormattedMessage {...messages.invoicesBannerOverdue} />:
                                    </span>
                                    <span className="organisationInvoicesBanner__summaryValue">
                                        {dueText}
                                    </span>
                                    {showPaid ? (
                                        <span className="organisationInvoicesBanner__paid">
                                            <FormattedMessage {...messages.invoicesBannerPaid} />: {paidText}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            {(hasBucketUp30 || hasBucket31to60 || hasBucket61to90 || hasBucketOver90) ? (
                                <div className="organisationInvoicesBanner__buckets">
                                    {hasBucketUp30 ? (
                                        [
                                            <div key="bucket-up30-label" className="organisationInvoicesBanner__bucketLabel">• <FormattedMessage {...messages.invoicesBannerUpTo30} />:</div>,
                                            <div key="bucket-up30-value" className="organisationInvoicesBanner__bucketValue">{dueUp30Text}</div>,
                                        ]
                                    ) : null}
                                    {hasBucket31to60 ? (
                                        [
                                            <div key="bucket-31to60-label" className="organisationInvoicesBanner__bucketLabel">• <FormattedMessage {...messages.invoicesBanner31to60} />:</div>,
                                            <div key="bucket-31to60-value" className="organisationInvoicesBanner__bucketValue">{due31to60Text}</div>,
                                        ]
                                    ) : null}
                                    {hasBucket61to90 ? (
                                        [
                                            <div key="bucket-61to90-label" className="organisationInvoicesBanner__bucketLabel">• <FormattedMessage {...messages.invoicesBanner61to90} />:</div>,
                                            <div key="bucket-61to90-value" className="organisationInvoicesBanner__bucketValue">{due61to90Text}</div>,
                                        ]
                                    ) : null}
                                    {hasBucketOver90 ? (
                                        [
                                            <div key="bucket-over90-label" className="organisationInvoicesBanner__bucketLabel">• <FormattedMessage {...messages.invoicesBannerOver90} />:</div>,
                                            <div key="bucket-over90-value" className="organisationInvoicesBanner__bucketValue">{dueOver90Text}</div>,
                                        ]
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="organisationInvoicesBanner__action">
                        <Link className="organisationInvoicesBanner__button" to={invoicesUrl}>
                            <i aria-hidden="true" className="fa fa-list-ul organisationInvoicesBanner__buttonIcon" />
                            <span><FormattedMessage {...messages.invoicesBannerOpenInvoices} /></span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    blockUnblockOrganisation = (blocked, reason = '') => {
        let organisation = this.props.user.organisation;
        return new Promise((resolve, reject) => {
            this.props.relay.commitUpdate(
                new BlockUnblockOrganisationMutation({
                    organisation_id: organisation.realId,
                    blocked,
                    reason,
                }),
                {
                    onSuccess: () => {
                        this.props.relay.forceFetch();
                        resolve();
                    },
                    onFailure: (transaction) => {
                        reject(mutationError(transaction, false));
                    },
                }
            );
        });
    };

    askForBlockReason = () => {
        return new Promise((resolve) => {
            bootbox.prompt({
                title: `<strong>${this.props.intl.formatMessage(messages.blockOrganisationReasonTitle)}</strong><br/><br/>${this.props.intl.formatMessage(messages.blockOrganisationReasonPrompt)}`,
                value: '',
                inputType: 'textarea',
                required: true,
                buttons: {
                    cancel: {
                        label: this.props.intl.formatMessage({ id: 'common.cancel', defaultMessage: 'Cancel' }),
                        className: "btn-link btn-storno"
                    },
                    confirm: {
                        label: this.props.intl.formatMessage(messages.blockOrganisationConfirmText),
                        className: "btn-danger"
                    }
                },
                callback: (result) => {
                    if (result === null) {
                        resolve(null);
                        return;
                    }
                    let reason = String(result || '').trim();
                    if (!reason) {
                        bootbox.alert(this.props.intl.formatMessage(messages.blockOrganisationReasonRequired));
                        resolve(null);
                        return;
                    }
                    resolve(reason);
                }
            });
        });
    };

    onClickBlockUnblockOrganisation = (blocked) => {
        const organisation = this.props.user && this.props.user.organisation;
        if (!organisation || !BrowserPermission.isDeveloper(organisation.realId)) {
            return Promise.resolve();
        }

        if (blocked) {
            return this.askForBlockReason().then((reason) => {
                if (!reason) {
                    return Promise.resolve();
                }
                return this.blockUnblockOrganisation(true, reason);
            }).catch((e) => {
                return displayError(e);
            });
        }

        return ConfirmDialog(this.props.intl, {
            message: this.props.intl.formatMessage(messages.unblockOrganisationDescription),
            confirm: this.props.intl.formatMessage(messages.unblockOrganisation),
            confirmStyle: 'btn-danger'
        }).then(() => {
            return this.blockUnblockOrganisation(false, '');
        }).catch((e) => {
            if (e) {
                return displayError(e);
            }
            return Promise.resolve();
        });
    };

    onClick = (event) => {
        let parent = this.props.user.organisation;

        let path = urlMapping.getUrl(types['channels'], "create", parent);
        this.context.router.push(path);
    };

    goToScenarios = () => {
        let path = urlMapping.getUrl(types['scenarios'], "list-all");
        this.context.router.push(path);
    }

    onChange = (event) => {
        let lastValue = event.target.value;

        /* wait 250 ms after last change */
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
        }

        this.delayTimeout = setTimeout(() => {
            this.props.relay.setVariables({
                searchName: lastValue
            });
        }, 250);
    };

    showExplanation(data) {
        let metadata = types['channels'];

        if (metadata.canUserCreate() && metadata.canCreate(BrowserPermission.getPermissionObject(), null, this.props.user.organisation.realId)) {
            return (
                <div>
                    <div style={{width: '100%', textAlign: 'center', paddingBottom: '1em',  paddingTop: '2em'}}><FormattedMessage
                        defaultMessage="You haven't added any App yet. Add the first one and see data from your favorite apps - Helpdesk, CRM, Accounting and many more."
                        id="organisation.emptyExplanation"/></div>

                    <div className="bottom-corner">
                        <button className="btn btn-primary btn-lg" onClick={this.onClick}>
                            <FormattedMessage
                                defaultMessage="Start adding first App"
                                id="organisation.startAddingChannels"/>
                        </button>
                    </div>
                </div>
            );
        } else {

            return (
                <div>
                    <FormattedMessage
                        defaultMessage="You haven't added any App yet, so you can't enjoy all the data. Ask administrator to add first one."
                        id="organisation.emptyExplanationWithoutPermission"/>
                </div>
            );
        }
    }

    componentDidMount() {
        this.setUsedScenariosOverflow();
        this.resizeListener = this.setUsedScenariosOverflow.bind(this);

        window.addEventListener("resize", this.resizeListener);
    }

    updateDimensions() {
        this.setUsedScenariosOverflow();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeListener);
    }

    setUsedScenariosOverflow() {
        let self = this;

        if (this.usedScenariosEl) {
            setTimeout(() => {
                self.setState({
                    usedScenariosOverflow: self.usedScenariosEl.offsetHeight < self.usedScenariosEl.lastElementChild.offsetTop
                });
            }, 0);
        }
    }

    renderOrganisationLabels(org) {
        // Labels hold internal identifiers, so show them only to support staff.
        if (!org || !BrowserPermission.hasOrganisationPermission(Permission.PERM_INSTANCE_SUPPORT, org.realId)) {
            return null;
        }

        const labels = parseOrganisationLabels(org.labels);
        if (labels.length === 0) {
            return null;
        }

        return (
            <small className="organisationLabels" style={{marginLeft: '12px'}}>
                {labels.map((label) => <span className="label label-default" key={label} style={{marginRight: '4px'}}>{label}</span>)}
            </small>
        );
    }

    renderOrgMenu() {
        let type = types['organisations'];
        let organisation = this.props.user.organisation;
        const url = `/organisations/${getUISettings().organisationId}/channels/${getUISettings().channelId}/${getUISettings().addonType}?erp=${getUISettings().erp}`;

        if ((getUISettings().isUpgatesAddon || getUISettings().isEshopRychleAddon) && getUISettings().hideOrganisationSettings) {
            return (
                <div className="orgMenu">
                    <div className="dropdown pull-right">
                        <Link className="btn btn-default pull-right" to={url}>
                            <i className="fa fa-fw fa-puzzle-piece" />&nbsp;{this.props.intl.formatMessage(messages.addonSettingsButton)}
                        </Link>
                    </div>
                </div>
            );
        }

        let canUpdate = organisation && type.canUserUpdate(organisation) && type.canUpdate(BrowserPermission.getPermissionObject(), organisation, organisation.realId);
        let canDelete = organisation && type.canUserDelete(organisation) && type.canDelete(BrowserPermission.getPermissionObject(), organisation, organisation.realId);
        let canBlockUnblock = canUpdate && BrowserPermission.isDeveloper(organisation.realId);

        if (!canUpdate && !canDelete || !organisation) {
            return null;
        }
        const exitFormLink = `https://docs.google.com/forms/d/e/1FAIpQLScbM5EwZmIxVvYMpmxOi6zwsYhbVZahtFUO5hzeBj9_oipi7w/viewform?usp=pp_url&entry.121282655=${organisation.realId}&entry.1312277406=${organisation.name}`;

        return (
            <div className="orgMenu">
                <div className="dropdown pull-right">
                    <button aria-expanded="true" aria-haspopup="true" className="btn btn-inline dropdown-toggle" data-toggle="dropdown" id="dropdownOrgMenu" type="button">
                        <span className="fa-lg glyphicon glyphicon-option-vertical" />
                    </button>
                    <ul aria-labelledby="dropdownOrgMenu" className="dropdown-menu" role="menu">
                        {canUpdate ? (<li className="dropdown-item">
                            <Link className="dropdown-item" to={urlMapping.getUrl("organisations", "edit", organisation)}>
                                <i className="fa fa-fw fa-pencil" />&nbsp;<FormattedMessage defaultMessage="Edit organisation" id="Organisation.edit" />
                            </Link>
                        </li>) : null}
                        {canBlockUnblock ? (
                            <li className="dropdown-item">
                                <a className="dropdown-item" href="#" onClick={(e) => {
                                    e.preventDefault();
                                    this.onClickBlockUnblockOrganisation(!organisation.blocked);
                                }}>
                                    <i className={"fa fa-fw " + (organisation.blocked ? "fa-unlock" : "fa-lock")} />
                                    &nbsp;
                                    {organisation.blocked
                                        ? this.props.intl.formatMessage(messages.unblockOrganisation)
                                        : this.props.intl.formatMessage(messages.blockOrganisation)
                                    }
                                </a>
                            </li>
                        ) : null}
                        {canDelete ? (<li className="dropdown-item">
                            <DeleteButton
                                afterDelete={() => {
                                    window.location = urlMapping.getUrl('organisations', 'list');
                                }}
                                asLink
                                beforeDelete={() => {
                                    if (organisation && (
                                        organisation.channels.edges.length > 0 ||
                                        organisation.flows.edges.length > 0
                                    )) {
                                        return OkDialog(this.props.intl, {
                                            message: this.props.intl.formatMessage(messages.cantDelete),
                                        }).then(() => {
                                            return false;
                                        }).catch((e) => {
                                            return false;
                                        });
                                    }

                                    return true;
                                }}
                                className="dropdown-item"
                                confirmDialogConfig={{
                                    message: this.props.user.organisations && this.props.user.organisations.edges && this.props.user.organisations.edges.length > 1 ? this.props.intl.formatMessage(messages.deleteTitle) + `  <a target="_blank" href='${exitFormLink}'>${this.props.intl.formatMessage(messages.feedbackLongText)}</a>` : this.props.intl.formatMessage(messages.deleteLastTitle)
                                }}
                                data={organisation}
                                deleteFatQuery={Relay.QL `fragment on DeleteOrganisationPayload {
                                                                updatedNode {
                                                                    id
                                                                },
                                                                user {
                                                                    organisations(first: 100) {
                                                                        edges {
                                                                            node {
                                                                                id,
                                                                                realId,
                                                                                name,
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }`}
                                deleteMutation={Relay.QL `mutation { deleteOrganisation }`}
                                metadata={type}
                                title={<FormattedMessage defaultMessage="Delete organisation" id="Organisation.delete" />}
                                types={types}
                                urlMapping={urlMapping}
                            />
                        </li>) : null}

                        {/* <div><a href='https://forms.gle/grqfybYoeU14MQU18'> Poskytnout zpětnou vazbu</a></div> */}

                        <li className="dropdown-item" key="2">
                            <Link className="dropdown-item" to={urlMapping.getUrl(types['channelErrors'], 'list-org-type', this.props.user.organisation)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Errors" id="channelErrors.list" /></Link>
                        </li>

                        <li className="dropdown-item" key="tariffs">
                            <Link className="dropdown-item" to={urlMapping.getUrl(types['tariffs'], 'list', this.props.user.organisation)}><i className="fa fa-fw fa-credit-card"></i> <FormattedMessage defaultMessage="Tariffs" id="tariffs.list" /></Link>
                        </li>

                        <li className="dropdown-item" key="invoices">
                            <Link className="dropdown-item" to={urlMapping.getUrl('invoices', 'list', this.props.user.organisation)}><i className="fa fa-fw fa-file-text-o"></i> <FormattedMessage defaultMessage="Invoices" id="invoices.list" /></Link>
                        </li>

                        {BrowserPermission.hasOrganisationPermission(Permission.PERM_DEVELOPER, this.props.user.organisation.realId) && BrowserPermission.developerModeEnabled() ? [
                                <li className="divider" key="0" role="separator">
                                </li>,
                                <li className="dropdown-item" key="1">
                                    <Link className="dropdown-item" to={urlMapping.getUrl(types['fetches'], 'list-org', this.props.user.organisation)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="API Requests" id="fetches.list" /></Link>
                                </li>,

                                <li className="dropdown-item" key="3">
                                    <Link className="dropdown-item" to={urlMapping.getUrl(types['instances'], 'fetch-stats', {id: this.props.user.organisation.instance_id}) + "?organisation_id=" + this.props.user.organisation.realId}><i className="fa fa-fw fa-line-chart"></i> <FormattedMessage defaultMessage="API statistics" id="InstanceView.fetchStats" /></Link>
                                </li>,
                                <li className="dropdown-item" key="4">
                                    <Link className="dropdown-item" to={urlMapping.getUrl(types['flowInvocations'], 'list-org', this.props.user.organisation)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Invocation history" id="flow.flowInvocations" /></Link>
                                </li>,
                                <li className="dropdown-item" key="5">
                                    <Link className="dropdown-item" to={urlMapping.getUrl(types['organisationEvents'], 'list-org', this.props.user.organisation)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Events in organisation" id="organisationEvents.list" /></Link>
                                </li>,
                                <li className="dropdown-item" key="6">
                                    <Link className="dropdown-item" to={urlMapping.getUrl(types['billingRules'], 'list', this.props.user.organisation)}><i className="fa fa-fw fa-dollar"></i> <FormattedMessage defaultMessage="Billing rules" id="flow.billingRules" /></Link>
                                </li>,
                                <li className="dropdown-item" key="7">
                                    <Link className="dropdown-item" to={urlMapping.getUrl(types['organisations'], 'runningJobs', this.props.user.organisation)}><i className="fa fa-fw fa-lock"></i> <FormattedMessage defaultMessage="Running Tasks" id="InstanceView.runningJobs" /></Link>
                                </li>,
                        ]
                        : null}
                        <li className="divider" key="0" role="separator"></li>
                        <li className="dropdown-item" key="3">
                            <Link className="dropdown-item" href={exitFormLink}><i className="fa fa-fw fa-bullhorn"></i> <FormattedMessage defaultMessage="Give us your opinion" id="feedback.shortText" /></Link>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    render() {
        const data = this.props.user.organisation;
        let myDativery = this.props.intl.formatMessage(messages.myDativery);
        let title = data.name;

        if (data && data.flows && data.flows.edges && data.flows.edges.length === 0 && data.channels.edges.length === 0) {
            return (
                <AppPanel className="organisationView empty" title={title}>
                    {this.renderOrgMenu()}
                    <span className="flex"></span>
                    <div className="content emptyScreen">
                        <img src="/cdn/menu_icons/ilustrace_bloky.svg" width="300" />
                        <h2>{myDativery}</h2>
                        <span className="description">
                            <FormattedMessage
                                defaultMessage="Dativery provides an easy way to integrate applications via scenarios."
                                id="organisation.noUsedScenariosExplanation"
                            />
                        </span>
                        {!getUISettings().hideScenarios && (
                            <div>
                                <button className="btn btn-primary btn-lg start" onClick={this.goToScenarios}>
                                    <FormattedMessage defaultMessage="Find Integration Scenarios" id="organisation.startScenario" />
                                    &nbsp;<svg className="icon-text" focusable="false" height="12px" version="1.1" viewBox="0 0 8 12" width="8px" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd" id="Symbols" stroke="none" strokeWidth="1"><g fill="#FFFFFF" id="Web/Submit/Active" transform="translate(-148.000000, -32.000000)"><polygon id="Shape" points="148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38"></polygon></g></g></svg>
                                </button>
                            </div>
                        )}
                    </div>
                    <span className="flex"></span>
                </AppPanel>
            );
        }

        return (
                <AppPanel breadcrumbParams={[{type: types['organisations'], data: this.props.user.organisation}]} className="organisationView" title={title}>
                {/*<div className="btn-toolbar hidden-xs" role="toolbar" style={{float: 'right', marginTop: '-3px'}}>
                    <div className="input-group" style={{maxWidth: '180px'}}>
                        <input className="form-control" name="search" onChange={this.onChange} placeholder={this.props.intl.formatMessage(messages.search)} type="text" />
                        <span className="input-group-addon" id="basic-addon2"><span className="fa fa-search"/></span>
                    </div>
                </div>*/}

                {!data.billingInfoFilled && data.showMissingBillingInfo && !BrowserPermission.developerModeEnabled() ? <AnnouncementBox icon="credit-card" title={this.props.intl.formatMessage(messages.missingBillingTitle)} message={this.props.intl.formatMessage(messages.missingBillingText)} ctaText={this.props.intl.formatMessage(messages.missingBillingAction)} onClick={() => {
                    let path = urlMapping.getUrl(types['organisations'], "edit", data);
                    this.context.router.push(path);                    
                }} position="top-right" /> : null}


                {this.renderOrgMenu()}
                <h2 className="title-underline">{data.logo ? <img src={data.logo} style={{maxWidth: '48px', maxHeight: '48px', paddingRight: '8px', marginTop: '-15px'}}/> : null}{title ? title : <FormattedMessage defaultMessage="My Organisation" id="menu.home2" />}{this.renderOrganisationLabels(data)}</h2>
                {data ? this.renderOrganisationInvoicesBanner(data) : null}
                {BrowserPermission.hasOrganisationPermission(Permission.PERM_INSTANCE_SUPPORT, this.props.user.organisation.realId) && BrowserPermission.developerModeEnabled() && this.props.user.organisation.consultant
                    ? <div style={{"height": "40px"}}><div style={{"float": "right", "height": "40px"}}><UserRenderer user={this.props.user.organisation.consultant} /></div><br/></div>
                    : null
                }

                {!data ? <p className="organisationMissing"><FormattedMessage defaultMessage="Organisation has been deleted or you do not have permission to access it." id="organisation.noPermission" /></p> : null}


                {data.blocked ? <div className="channelError">
                    <div className="alert alert-danger" role="alert">
                        <div className="glyphicon glyphicon-exclamation-sign"></div>
                        <div>
                                <div>
                                    <h3><FormattedMessage defaultMessage="Organisation has been blocked" id="organisation.orgHasBeenBlocked" /></h3>
                                    {data.blockedReason ? <span><FormattedMessage defaultMessage="Reason: " id="organisation.reason" /> <strong>{data.blockedReason}</strong></span> : ""}
                                </div>
                        </div>
                    </div>
                </div> : null}

                {BrowserPermission.hasOrganisationPermission(Permission.PERM_INSTANCE_SUPPORT, this.props.user.organisation.realId) && BrowserPermission.developerModeEnabled() && (this.props.user.organisation.implementationDetails || this.props.user.organisation.implementationDetailsLink) ?
                    <div>
                        <h4><FormattedMessage defaultMessage="Implementation Details:" id="organisation.implementationDetails" /></h4>
                        {this.props.user.organisation.implementationDetails ? <div><SafeHTML value={this.props.user.organisation.implementationDetails} /></div> : null}
                        {this.props.user.organisation.implementationDetailsLink ? <a href={this.props.user.organisation.implementationDetailsLink}>{this.props.user.organisation.implementationDetailsLink}</a> : null}
                    </div>
                : null}

                {data && data.flows.edges.length > 0 ? <div>
                    <FlowSimpleList organisation={data} />
                </div> : null}

                {data && data.channels.edges.length > 0
                    ?
                    <div className="connectedApplications">
                        <ChannelList asRow={false} organisation={data}/>
                    </div>
                    :
                    null
                }

                {!getUISettings().hideScenarios && (
                    <div className="center findIntegrationsButton">
                        <button className="btn btn-primary btn-lg start" onClick={this.goToScenarios}>
                            <FormattedMessage defaultMessage="Find Integration Scenarios" id="organisation.startScenario" />
                            &nbsp;<svg className="icon-text" focusable="false" height="12px" version="1.1" viewBox="0 0 8 12" width="8px" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd" id="Symbols" stroke="none" strokeWidth="1"><g fill="#FFFFFF" id="Web/Submit/Active" transform="translate(-148.000000, -32.000000)"><polygon id="Shape" points="148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38"></polygon></g></g></svg>
                        </button>
                    </div>
                )}

            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(OrganisationView), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        searchName: '',
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                featureFlags,
                organisation(id: $organisationId) {
                    id,
                    realId,
                    instance_id,
                    name,
                    labels,
                    logo,
                    description,
                    featureFlags,
                    implementationDetails,
                    implementationDetailsLink,
                    isBillable,
                    billingInfoFilled,
                    showMissingBillingInfo,
                    blocked,
                    blockedReason,
                    consultant {
                        id,
                        realId,
                        name,
                        firstname, 
                        surname, 
                        email,
                        picture
                    },
                    channels(first: 200, deleted: false) {
                        edges {
                            node {
                                id
                            }
                        }
                    },
                    flows(first: 200, deleted: false) {
                        edges {
                            node {
                                id
                            }
                        }
                    }
                    organisationOverdueBills(first: 3000) {
                        edges {
                            node {
                                id
                                realId
                                dueDate
                                totalAmount
                                amountToPay
                                currencyCode
                            }
                        }
                    }
                    ${FlowSimpleList.getFragment('organisation')},
                    usedScenarios(first: 100) {
                        edges {
                            node {
                                id,
                                realId,
                                scenario, {
                                    id,
                                    realId,
                                    title,
                                    ${ScenarioBox.getFragment('scenario')}
                                }
                            }
                        }
                    },
                    ${ChannelList.getFragment('organisation')},
                    relevantScenarios(first: 8, nameLike: $searchName) {
                        edges {
                            node {
                                id,
                                realId,
                                ${ScenarioBox.getFragment('scenario')}
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    }
                }
                organisations(first: 10000) {
                    edges {
                        node {
                            realId,
                        }
                    }
                }
            }
        `,
    },
});
